import React, { Component, useEffect } from 'react';
import { Link } from 'react-router-dom';
import footerdata from '../../data/footerdata.json';

const Footer_v1 = () => {

  useEffect(() => {
    let publicUrl = process.env.PUBLIC_URL + '/'
    const minscript = document.createElement("script");
    minscript.async = true;
    minscript.src = publicUrl + "assets/js/main.js";

    document.body.appendChild(minscript);

  }, [])

  let publicUrl = process.env.PUBLIC_URL + '/'
  let imgattr = "Footer logo"
  const inlineStyle = {
    backgroundImage: 'url(' + publicUrl + footerdata.footerbg + ')'
  }

//   const handleSubmit = () => {
// alert('hgjhgjhgjh')
//   }

  return (
    <footer className="footer-area">
      <div className="container">
        <div className="footer-top">
          <div className="row">
            <div className="col-sm-4" style={{ marginTop: "-25px"}}>
              <a className="footer-logo" href="/" ><img src={publicUrl + footerdata.footerlogo} alt={imgattr} /></a>
            </div>
            <div className="col-sm-8">
              <div className="footer-social text-sm-right">
                <span>FOLLOW US</span>
                <ul className="social-icon">
                  {footerdata.socialicon.map((item, i) =>
                    <li key={i}>
                      <a href={item.url} target="_blank"><i className={item.icon} /></a>
                     
                    </li>
                  )}
                   {/* <img src='assets/img/tiktok.png' style={{ width: "40px", borderRadius: "50%"}}></img> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="row">
            <div className="col-lg-4 col-sm-6">
              <div className="widget widget_nav_menu">
                <h4 className="widget-title">{footerdata.popularserces.title}</h4>
                <ul>
                  {footerdata.popularserces.links.map((item, i) =>
                    <li className="readeal-top" key={i}><Link to={item.url} >{item.title}</Link></li>
                  )}

                </ul>
              </div>
            </div>
            <div className="col-lg-5 col-sm-6">
              <div className="widget widget_nav_menu">
                <h4 className="widget-title">{footerdata.Homepress.title}</h4>
                <ul>
                  {footerdata.Homepress.links.map((item, i) =>
                    <li className="readeal-top" key={i}><Link to={item.url} >{item.title}</Link></li>
                  )}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="widget widget_nav_menu">
                <h4 className="widget-title">{footerdata.quicklink.title}</h4>
                <ul>
                  {footerdata.quicklink.links.map((item, i) =>
                    <li className="readeal-top" key={i}><Link to={item.url} >{item.title}</Link></li>
                  )}
                </ul>
              </div>
            </div>
            {/* <div className="col-lg-3 col-sm-6">
              <div className="widget widget-subscribe" >
                <div className="rld-single-input">
                  <input type="text" name="name" placeholder="Full Name" />
                </div>
                <div className="rld-single-input">
                  <input type="text" name="email" placeholder="Your@email.com" />
                </div>
                <button onClick={handleSubmit} className="btn btn-yellow w-100">Subscribe</button>
              </div>
            </div> */}
          </div>
        </div>
        <div className="copy-right text-center" dangerouslySetInnerHTML={{ __html: footerdata.copyrighttext }}></div>
      </div>
    </footer>

  )

}


export default Footer_v1